import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import { ChiamaAPI, Trad, Tipo, CampoNumero } from './';
import * as Dati from '../Dati';
import * as Glob from '../Globale';
import { NavLink } from 'react-router-dom';

interface ICoAssicurazioneProps extends Dati.IBaseProps {
    BinderProdotto: Glob.DatiJSON; //JSON
    Value: Glob.DatiJSON; //JSON mandanti
}

export class CoAssicurazione extends BasePureComponent<ICoAssicurazioneProps> {
    private _Dati: Dati.CDatoCoAssicurazione[] = [];
    private _BinderProdottoCoAss: Dati.CDatoBinderProdottoCoAssicurazione[] = [];
    private _QuotaRimanente: number = 100;
    private _Colorazione: string = "";

    public constructor(props: any) {
        super(props);
        this.ControlloDelegataria = this.ControlloDelegataria.bind(this);
        this.ControlloQuota = this.ControlloQuota.bind(this);
        this.CalcolaQuotaRimanente = this.CalcolaQuotaRimanente.bind(this);
    }

    private PopolaDati() {
        this.CostruisciStruttura(this.props.BinderProdotto);

        if (this.props.Value != undefined && this.props.Value != "") {
            this._Dati = JSON.parse(this.props.Value);
        }
        else {
            this._Dati = [];
        }

        for (let i: number = 0; i < this._BinderProdottoCoAss.length; i++) {
            this._BinderProdottoCoAss[i].Delegataria = false;
            this._BinderProdottoCoAss[i].Quota = 0;
            for (let y: number = 0; y < this._Dati.length; y++) {
                if (this._BinderProdottoCoAss[i].ID_AnagCompagnia == this._Dati[y].ID_Anag) {
                    this._BinderProdottoCoAss[i].Quota = this._Dati[y].Quota;
                    this._BinderProdottoCoAss[i].Delegataria = this._Dati[y].Delegataria;
                    this._BinderProdottoCoAss[i].ID_BinderCompagnia = this._Dati[y].ID_BinderCompagnia;
                }
            }
        }
    }

    private CostruisciStruttura(valore: Glob.DatiJSON) {
        if (valore != undefined && valore != "") {
            this._BinderProdottoCoAss = JSON.parse(valore);
        }
    }

    private CalcolaQuotaRimanente() {
        this._QuotaRimanente = 100;

        let DeleQuotaMassima = -1;
        let QuotaMassima = 0;
        let DeleCorrente = -1;
        let QuotaDeleCorrente = 0;
        for (let i: number = 0; i < this._BinderProdottoCoAss.length; i++) {
            this._QuotaRimanente = this._QuotaRimanente - (this._BinderProdottoCoAss[i].Quota != undefined ? this._BinderProdottoCoAss[i].Quota : 0);
            if (QuotaMassima <= this._BinderProdottoCoAss[i].Quota) {
                DeleQuotaMassima = i;
                QuotaMassima = this._BinderProdottoCoAss[i].Quota;
            }
            if (this._BinderProdottoCoAss[i].Delegataria) {
                DeleCorrente = i;
                QuotaDeleCorrente = this._BinderProdottoCoAss[i].Quota == undefined ? 0 : this._BinderProdottoCoAss[i].Quota;
            }
        }

        if (DeleCorrente == -1) {
            if (DeleQuotaMassima >= 0) {
                this._BinderProdottoCoAss[DeleQuotaMassima].Delegataria = true;
            }
        }
        else if (DeleCorrente != DeleQuotaMassima && QuotaDeleCorrente != QuotaMassima) {
            this._BinderProdottoCoAss[DeleCorrente].Delegataria = false;
            this._BinderProdottoCoAss[DeleQuotaMassima].Delegataria = true;
        }

        if (this._QuotaRimanente <= 100 && this._QuotaRimanente > 50) {
            this._Colorazione = "rosso";
        }
        else if (this._QuotaRimanente <= 50 && this._QuotaRimanente > 0) {
            this._Colorazione = "arancione";
        }
        else {
            this._Colorazione = "verde";
        }

        return this._QuotaRimanente;
    }

    protected OnAggiorna(campo: string, i: number, v: any): any {
        switch (campo) {
            case "Quota":
                this.ControlloQuota(i, v);
                break;
            case "Delegataria":
                for (let C: number = 0; C < this._BinderProdottoCoAss.length; C++) {
                    this._BinderProdottoCoAss[C].Delegataria = C == i;
                }
                this.CalcolaQuotaRimanente();
                this.ControlloDelegataria(null);
                break;
        }

        this._Dati = [];
        for (let C: number = 0; C < this._BinderProdottoCoAss.length; C++) {
            if (this._BinderProdottoCoAss[C].Quota > 0) {
                let dato = new Dati.CDatoCoAssicurazione();
                dato.ID_Anag = this._BinderProdottoCoAss[C].ID_AnagCompagnia;
                dato.Delegataria = this._BinderProdottoCoAss[C].Delegataria;
                dato.Quota = this._BinderProdottoCoAss[C].Quota;
                dato.ID_Binder = this._BinderProdottoCoAss[C].ID_Binder;
                dato.ID_BinderCompagnia = this._BinderProdottoCoAss[C].ID_BinderCompagnia;
                this._Dati.push(dato);
            }
        }

        this.props.OnChange(this.props.Name, JSON.stringify(this._Dati));
    }

    protected ControlloQuota(i: number, v: any) {
        let oldQuota: number = Number(this._BinderProdottoCoAss[i].Quota);
        this._BinderProdottoCoAss[i].Quota = Number(v);
        if (this.CalcolaQuotaRimanente() < 0) {
            Glob.InfoModaleWarning(Trad.Trad("WARNING"), Trad.TradParam("Impossibile impostare la quota di {1-R} perché supererebbe la soglia del 100% totale", [v]));
            if (oldQuota < this._BinderProdottoCoAss[i].CoAssicurazioneMinima) {
                this._BinderProdottoCoAss[i].Quota = 0.00;
            }
            else {
                this._BinderProdottoCoAss[i].Quota = oldQuota;
            }
        }
        this.CalcolaQuotaRimanente();
    }

    public ControlloDelegataria(e: any) {
        let errore: string = "";

        for (let x: number = 0; x < this._BinderProdottoCoAss.length; x++) {
            if (this._BinderProdottoCoAss[x].CoAssicurazioneSoloDelegataria
                && !this._BinderProdottoCoAss[x].Delegataria
                && Number(this._BinderProdottoCoAss[x].Quota) != 0) {
                errore += Trad.TradParam("La compagnia {1-S} richiede di essere delegataria", [this._BinderProdottoCoAss[x].DenominazioneCompagnia]);
            }
        }

        if (errore != "") {
            Glob.InfoModaleWarning(Trad.Trad("WARNING"), errore);
        }
    }

    public render() {
        this.PopolaDati();

        let valori: any[] = [];
        for (let i: number = 0; i < this._BinderProdottoCoAss.length; i++) {
            valori.push(<div className="form-group kt-form login-form__group row" key={i + 1}>
                <div className="col-lg-2">
                    <label>{Trad.Trad("Binder")}</label> <br /><NavLink className="special" to={"/binder/" + this._BinderProdottoCoAss[i].ID_Binder}>{this._BinderProdottoCoAss[i].CodiceBinder}</NavLink>
                </div>
                <div className="col-lg-2">
                    <label>{Trad.Trad("Denominazione")}</label> <br /><span className="tag">{this._BinderProdottoCoAss[i].DenominazioneCompagnia}</span>
                </div>
                <div className="col-lg-1">
                    <span className="tag"><label>{Trad.Trad("Data effetto")}</label>  <br />{Trad.TradParam("{1-D}", [this._BinderProdottoCoAss[i].DataEffetto])}</span>
                </div>
                <div className="col-lg-1">
                    <span className="tag">  <label>{Trad.Trad("Data fine")}</label> <br /> {Trad.TradParam("{1-D}", [this._BinderProdottoCoAss[i].DataFine])}</span>
                </div>
                <div className="col-lg-2">
                    <span className="tag"><label>{Trad.Trad("Limite per contraente")}</label>  <br />{Trad.TradParam("{1-I}", [this._BinderProdottoCoAss[i].LimitePerSingoloContraente])}</span>
                </div>
                <div className="col-lg-1">
                    <span className="tag">   <label>{Trad.Trad("Premio minimo")}</label> <br /> {Trad.TradParam("{1-I}", [this._BinderProdottoCoAss[i].PremioMinimo])}</span>
                </div>
                <div className="col-lg-1"><label>{Trad.Trad("CoAssicurazione minima")}</label>  <br />
                    <span className="tag">{Trad.TradParam("CoAssMinimaSoloDelegataria", [this._BinderProdottoCoAss[i].CoAssicurazioneMinima, this._BinderProdottoCoAss[i].CoAssicurazioneSoloDelegataria ? " *" : ""])}</span>
                </div>
                <div className="col-lg-1"><label>{Trad.Trad("% assicurata")}</label> <br />
                    <CampoNumero Valore={this._BinderProdottoCoAss[i].Quota} Id={"Quota_" + i} Name={"Quota_" + i} OnChange={(e) => { this.OnAggiorna("Quota", i, (e as React.FormEvent<any>).currentTarget.value) }} CSS="input tag TextLeft" Icona="" Minimo={this._BinderProdottoCoAss[i].CoAssicurazioneMinima} Massimo={100} ValoreNeutro={0} OnBlur={this.ControlloDelegataria} Scrittura={this._BinderProdottoCoAss.length > 1} />
                </div>
                <div className="col-lg-1">
                    <label>{Trad.Trad("Delegataria")}</label> <br />
                    <input type="checkbox" className="tag" value="Delegataria" checked={this._BinderProdottoCoAss[i].Delegataria} onChange={(e) => { this.OnAggiorna("Delegataria", i, e.currentTarget.checked) }} />
                </div>
            </div>);
        }

        return <div className={"kt-portlet bg-fill-brand kt-portlet--head-solid-bg kt-portlet--bordered " + this.props.CSS}>
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-user"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Assicuratori")}
                        </h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <li className="kt-portlet__nav-item">
                            <label className={this._Colorazione}>
                                <i className="la la-bar-chart-o"></i>
                                {Trad.Trad("Quota rimanente")}: {this._QuotaRimanente} %
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="kt-portlet__body">
                {valori}
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/CoAssicurazione.tsx